<template>
    <v-menu
        ref="menuYear"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-btn
                icon
                v-on="on"
            >
                <v-icon>mdi-calendar-month</v-icon>
            </v-btn>

        </template>
            <v-sheet>
                <v-select
                    v-model="esteYear"
                    :items="allYears"
                    class="mx-3"
                    label="Año"
                    @input="menu=false"
                />
                <v-btn color="primary" @click="cambiaYear">Este año</v-btn>
            </v-sheet>
    </v-menu>
</template>

<script>
export default {
    props:{
        year:String,
        maxYear:Number
    },
    data:()=>({
        menu:false,
    }),
    methods:{
        cambiaYear(){
            this.menu=false
            this.setHoy()
        },
        setHoy(){
            this.esteYear = this.moment(new Date()).format('YYYY')
        },
    },
    computed:{
        esteYear:{
            get(){return parseInt(this.year)},
            set(v){this.$emit('update:year',v)}
        },
        allYears(){
            let esteYearIni = parseInt(this.moment(new Date()).format('YYYY'))
            let inicio
            if (!this.maxYear){
                inicio = 2015
            } else {
                inicio = this.maxYear
            }
            let total = esteYearIni - inicio
            let anios = []
            for (let i = 0; i <= total; i++) {
                anios.push(esteYearIni - i)
            }
            return anios
        }
    },
}
</script>

<style>

</style>